
import Vue from "vue";
import NavMain from "@/features/shared/components/NavMain.vue";
import AppFooter from "@/features/shared/components/AppFooter.vue";
import Component from "vue-class-component";
import globalLoader from "@/globalLoader";
import Loader from "@/features/shared/components/Loader";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {oidcCallbackName, oidcSilentRefreshCallbackName} from "@/router";
import {authService} from "@/AuthService";
import VueRouter from "vue-router";
import ConcurrencyWarningModal from "@/components/ConcurrencyWarningModal.vue";

@Component({
    components: {
        NavMain,
        AppFooter,
        LoadingSpinner,
        ConcurrencyWarningModal
    },
})
export default class App extends Vue {
    globalLoader: Loader = globalLoader;

    routeClassName: string | null | undefined = "";

    get isOidcHappening(): boolean {
        return this.$route.name === oidcCallbackName
            || this.$route.name === oidcSilentRefreshCallbackName;
    }

    async created() {
        this.globalLoader.endLoading();

        // OIDC endpoints are handled here. Handling it here makes mounting/unmounting loaders simpler.
        this.$watch(
            () => this.$route.name,
            async (routeName) => {
                this.routeClassName = routeName;

                if (routeName === oidcCallbackName) {
                    await authService.completeAuthentication()
                        .then(returnUrl => {
                            this.$router.replace(returnUrl);
                        })
                        // Acknowledge Vue warnings that are generated when using navigation guards to redirect user to profile selection or auto-choose seafarer profile.
                        .catch((e) => {
                            const failureTypeRedirected = 1; // NavigationFailureTypeE.redirected
                            if (!VueRouter.isNavigationFailure(e, failureTypeRedirected)) {
                                Promise.resolve(e);
                            }
                        });
                } else if (routeName === oidcSilentRefreshCallbackName) {
                    await authService.completeSilentRefresh();
                }
            },
            {immediate: true})
    }
}
